"use strict";
/**
 * @namespace Clipboard
 * @description Components that help copy text to clipboard
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../codegen/Messages");
var ScreenReaderOnly_1 = require("@oui/core/ScreenReaderOnly");
var index_1 = require("../index");
/**
 * OUI ClipboardLink component.
 *
 * @oui-component ClipboardLink
 */
var ClipboardLink = /** @class */ (function (_super) {
    __extends(ClipboardLink, _super);
    function ClipboardLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClipboardLink.prototype.render = function () {
        var _a = this.props, text = _a.text, copyLabel = _a.copyLabel, copiedLabel = _a.copiedLabel, testId = _a.testId;
        return (React.createElement(GenericClipboard, { text: text }, function (copy, copied) { return (React.createElement(index_1.Button, { type: index_1.ButtonType.Button, buttonStyle: index_1.ButtonStyle.MutedLink, onClick: copy, testId: testId, pressed: copied ? "true" : "false" }, copied
            ? copiedLabel || Messages.Clipboard.copied()
            : copyLabel || Messages.Clipboard.copy())); }));
    };
    return ClipboardLink;
}(React.PureComponent));
exports.ClipboardLink = ClipboardLink;
var ClipboardAction = /** @class */ (function (_super) {
    __extends(ClipboardAction, _super);
    function ClipboardAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClipboardAction.prototype.render = function () {
        var _a = this.props, text = _a.text, copyLabel = _a.copyLabel, copiedLabel = _a.copiedLabel, testId = _a.testId;
        return (React.createElement(GenericClipboard, { text: text }, function (copy, copied) { return (React.createElement(index_1.Action, { key: "oui-clipboard-action", onClick: copy, testId: testId }, copied
            ? copiedLabel || Messages.Clipboard.copied()
            : copyLabel || Messages.Clipboard.copy())); }));
    };
    return ClipboardAction;
}(React.PureComponent));
exports.ClipboardAction = ClipboardAction;
var GenericClipboard = /** @class */ (function (_super) {
    __extends(GenericClipboard, _super);
    function GenericClipboard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { copied: false };
        _this.copy = _this.copy.bind(_this);
        _this.copyRef = React.createRef();
        return _this;
    }
    GenericClipboard.prototype.copy = function () {
        var _this = this;
        this.setState({ copied: true });
        setTimeout(function () {
            _this.setState({ copied: false });
        }, 3000); // tslint:disable-line align
        this.copyRef.current.select();
        document.execCommand("copy");
    };
    GenericClipboard.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.props.children(this.copy, this.state.copied),
            React.createElement(ScreenReaderOnly_1.default, null,
                React.createElement("textarea", { ref: this.copyRef, value: this.props.text }))));
    };
    return GenericClipboard;
}(React.PureComponent));
//# sourceMappingURL=Clipboard.js.map